import React, { useState, useEffect, useContext, useRef, useMemo } from "react";
import axios from "axios";
import { Form, Field } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import classNames from "classnames";
import DatePicker from "react-datepicker";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
// import getDay from "date-fns/getDay";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Meetings/Main/Meeting/Meeting.css";

import context from "../../../../../context/auth-context";
import errorHandler from "../../../../../hoc/ErrorHandler";
import { IS_EMPTY } from "../../../../../constants";
import InlinePreloader from "../../../../UI/InlinePreloader/InlinePreloader";
import { Stack } from "@mui/material";
import MeetingPackAutocomplete from "./MeetingPackAutocomplete";
import { isArray, isNull, isUndefined } from "lodash";

// const isWeekday = (date) => {
//   const day = getDay(date);
//   return day !== 0 && day !== 6;
// };

const required = (value) => (value ? undefined : "Required");

const AddEvent = ({ createHandler, eventDate }) => {
  // ================================= | STATES | =================================== //
  const [eventType, setEventType] = useState(null);
  const [canCreateFolder, setCanCreateFolder] = useState(true);
  const [meetingGroups, setMeetingGroups] = useState({
    loading: true,
    groups: null,
    virtualHosts: null,
    error: null,
  });
  const [meetingType, setMeetingType] = useState({
    loading: true,
    meetingTypeId: null,
    users: null,
    nonUser: null,
    meetingPacks: null,
    error: null,
  });
  // ================================= | REFS | =================================== //
  const formRef = useRef(null);
  const resetForm = useRef(null);
  // ================================= | MEMO | =================================== //
  const initialValueFn = useMemo(() => meetingType.users ? meetingType.users.map(x => x.id) : [], [meetingType.users])
  // ================================= | CONTEXT | =================================== //
  const { accessToken, companyId } = useContext(context);

  const isEmpty = value => {
    if (value) {
      return Array.isArray(value) ? undefined : 'Required'
    } else {
      return undefined
    }
  }
  // ================================= | EXTRACTED ID | =================================== //
  const { meetingTypeId } = meetingType;
  // ================================= | EVENTS | =================================== //
  const getUserResourcePermissions = (resource_id) => {
    return axios.get(
      `/resources/${resource_id}/user-permissions`
    );
  };
  // ================================= | EFFECTS | =================================== //
  useEffect(() => {
    if (eventType && eventType === "meeting" && !meetingGroups.groups) {
      (async () => {
        const meetingGroups = () => axios.get("/meetings/meeting-groups");
        const zoomAccounts = () => axios.get("/meetings/zoom-accounts");
        const zoomUsers = () => axios.get("/meetings/zoom-users");

        const response = await axios.all([
          meetingGroups(),
          zoomAccounts(),
          zoomUsers(),
        ]);

        if (response) {
          const [meetingGroups, zoomAccounts, zoomUsers] = response;
          const virtualHosts = [];

          if (zoomAccounts && zoomUsers) {
            zoomAccounts.data.map((account) => {
              const userIndex = zoomUsers.data?.users.findIndex(
                (user) =>
                  user.status === "active" && user.email === account.email
              );
              return (
                userIndex >= 0 &&
                virtualHosts.push(zoomUsers.data.users[userIndex])
              );
            });
          }

          return setMeetingGroups((pristine) => ({
            ...pristine,
            loading: false,
            ...(!IS_EMPTY(virtualHosts)
              ? {
                virtualHosts: virtualHosts,
              }
              : {}),
            groups: meetingGroups?.data,
          }));
        } else {
          return setMeetingGroups((pristine) => ({
            ...pristine,
            loading: false,
            error: true,
          }));
        }
      })();
    }
  }, [accessToken, companyId, eventType, meetingGroups]);

  useEffect(() => {
    if (meetingTypeId)
      (async () => {
        const users = () => axios.get(`/groups/${meetingTypeId}/users`);
        const nonUsers = () => axios.get(`/groups/${meetingTypeId}/non-users`);
        const folders = () => axios.get(`/groups/${meetingTypeId}/folders`);
        const response = await axios.all([users(), nonUsers(), folders()]);

        if (response) {
          const [users, nonUsers, folders] = response;
          let userList;
          let nonUserList;
          let groupMeetingPacks = null;
          

          if (isArray(users.data)) {
            userList = users.data.filter(
              (user) => user.active === "Y");
            if (!isNull(formRef.current) && !isUndefined(formRef.current)) {
              formRef.current.mutators.setFormAttribute("invitees", userList.map(user => user.id));
            }
          }

          if (nonUsers)
            nonUserList = nonUsers.data.filter(
              (user) => user.active === "Y");
          if (folders)
            groupMeetingPacks = folders.data.filter(
              (folder) =>
                folder.is_meeting === "Y" || folder.is_meeting_pack === "Y"
            );

          return setMeetingType((pristine) => ({
            ...pristine,
            loading: false,
            users: userList,
            nonUser: nonUserList,
            ...(!IS_EMPTY(groupMeetingPacks)
              ? {
                meetingPacks: groupMeetingPacks,
              }
              : {}),
          }));
        } else {
          return setMeetingType((pristine) => ({
            ...pristine,
            loading: false,
            error: true,
          }));
        }
      })();

    return setMeetingType({
      loading: true,
      users: null,
      meetingTypeId: null,
      meetingPacks: null,
      error: false,
    });
  }, [meetingTypeId]);


  return (
    <Form
      onSubmit={(event) => {
        createHandler(event);
        setTimeout(() => resetForm.current.click(), 1000);
      }}
      mutators={{
        setFormAttribute: ([fieldName, fieldVal], state, { changeValue }) => {
          changeValue(state, fieldName, () => fieldVal);
        },

      }}
      initialValues={{ dateTime: eventDate, invitees: null, selectAllInvitees: true, tag: '1' }}
      render={({ handleSubmit, form, submitting, pristine, values }) => {
        formRef.current = form;
        return <form autoComplete="off" onSubmit={handleSubmit}>
          <div
            className="form-group form-material floating"
            data-plugin="formMaterial"
          >
            <Field name="title" validate={required}>
              {({ input, meta }) => (
                <>
                  <input
                    {...input}
                    type="text"
                    id="title"
                    className="form-control"
                  />
                  {meta.error && meta.touched && (
                    <span style={{ color: "#f44336" }}>{meta.error}</span>
                  )}
                </>
              )}
            </Field>
            <label className="floating-label" htmlFor="title">
              Event Title<sup>*</sup>
            </label>
          </div>
          <div className="text-center">
            <div
              className="btn-group btn-group-sm"
              aria-label="Event type button group"
              role="group"
            >
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "meeting" }
                )}
                onClick={() => form.change("type", "meeting")}
                style={{
                  color:
                    form.getState().values.type === "meeting"
                      ? "#3f51b5"
                      : "inherit",
                }}
              >
                <span>
                  <i className="icon fa-users" aria-hidden="true"></i>Meeting
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "approval" }
                )}
                onClick={() => form.change("type", "approval")}
                style={{
                  color:
                    form.getState().values.type === "approval"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon md-check-all" aria-hidden="true"></i>
                  Approval
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "evaluation" }
                )}
                onClick={() => form.change("type", "evaluation")}
                style={{
                  color:
                    form.getState().values.type === "evaluation"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon ti-bar-chart-alt" aria-hidden="true"></i>
                  Evaluation
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "plan" }
                )}
                onClick={() => form.change("type", "plan")}
                style={{
                  color:
                    form.getState().values.type === "plan"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon ti-timer" aria-hidden="true"></i>Plan
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "alert" }
                )}
                onClick={() => form.change("type", "alert")}
                style={{
                  color:
                    form.getState().values.type === "alert"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon ti-bell" aria-hidden="true"></i>Alert
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "discussion" }
                )}
                onClick={() => form.change("type", "discussion")}
                style={{
                  color:
                    form.getState().values.type === "discussion"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon ti-comments" aria-hidden="true"></i>
                  Discussion
                </span>
              </button>
              <button
                type="button"
                className={classNames(
                  "btn btn-default btn-animate btn-animate-side waves-effect waves-classic",
                  { focus: form.getState().values.type === "election" }
                )}
                onClick={() => form.change("type", "election")}
                style={{
                  color:
                    form.getState().values.type === "election"
                      ? "#3f51b5"
                      : "inherit",
                }}
                disabled
              >
                <span>
                  <i className="icon ti-check-box" aria-hidden="true"></i>
                  Election
                </span>
              </button>
            </div>
          </div>
          <OnChange name="type">{(value) => setEventType(value)}</OnChange>
          {form.getState().values.type === "meeting" && (
            <>
              <div className="row">
                <div className="col-md-9">
                  <div
                    className="form-group form-material floating"
                    data-plugin="formMaterial"
                  >
                    <Field name="dateTime" validate={required}>
                      {({ input, meta }) => (
                        <>
                          <DatePicker
                            {...input}
                            className="form-control"
                            selected={form.getState().values.dateTime}
                            showTimeSelect
                            dateFormat="MMMM d, yyyy h:mm aa"
                            isClearable
                            placeholderText="Event Date"
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "#f44336" }}>
                              {meta.error}
                            </span>
                          )}
                        </>
                      )}
                    </Field>
                    <OnChange name="dateTime">
                      {(_) => {
                        (isUndefined(form.getState().values.dateTime) || isNull(form.getState().values.dateTime)) &&
                          form.mutators.setFormAttribute("endTime", null);
                      }
                      }
                    </OnChange>
                  </div>
                </div>
                <div className="col-md-3">
                  <div
                    className="form-group form-material floating"
                    data-plugin="formMaterial"
                  >
                    <Field name="endTime" validate={required}>
                      {({ input, meta }) => (
                        <>
                          <DatePicker
                            {...input}
                            className="form-control"
                            selected={form.getState().values.endTime}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={10}
                            timeCaption="End Time"
                            minTime={form.getState().values.dateTime ?? setHours(setMinutes(new Date(), 30), 12)}
                            maxTime={setHours(setMinutes(new Date(), 30), 23)}
                            dateFormat="h:mm aa"
                            isClearable
                            placeholderText="End time"
                            disabled={isUndefined(form.getState().values.dateTime) || isNull(form.getState().values.dateTime)}
                          />
                          {meta.error && meta.touched && (
                            <span style={{ color: "#f44336" }}>
                              {meta.error}
                            </span>
                          )}
                        </>
                      )}
                    </Field>

                  </div>
                </div>
              </div>
              <ul className="list-unstyled list-inline">
                <li className="list-inline-item">
                  <Field name="tag" type="radio" value="1">
                    {({ input, meta }) => (

                      <div className="radio-custom radio-default">
                        <input
                          {...input}
                          type="radio"
                          id="physical"
                          value="1"
                          checked={input.checked}
                          onChange={input.onChange}
                        />
                        <label
                          htmlFor="physical"
                          data-tip="Face to face"
                          data-place="top"
                          data-type="info"
                        >
                          Physical
                        </label>
                      </div>
                    )}
                  </Field>
                </li>

                {!meetingGroups.loading ? (
                  meetingGroups.virtualHosts && (
                    <>
                      <Field name="tag" type="radio" value="2">
                        {({ input, meta }) => (

                          <li className="list-inline-item">
                            <div className="radio-custom radio-warning">
                              <input
                                {...input}
                                type="radio"
                                id="virtual"
                                value="2"
                                checked={input.checked}
                                onChange={input.onChange}
                              />
                              <label
                                htmlFor="virtual"
                                data-tip="Web conferencing"
                                data-place="top"
                                data-type="info"
                              >
                                Virtual
                              </label>
                            </div>
                          </li>
                        )}
                      </Field>
                      <Field name="tag" type="radio" value="3">
                        {({ input, meta }) => (

                          <li className="list-inline-item">
                            <div className="radio-custom radio-success">
                              <input
                                {...input}
                                type="radio"
                                id="hybrid"
                                value="3"
                                checked={input.checked}
                                onChange={input.onChange}
                              />
                              <label
                                htmlFor="hybrid"
                                data-tip="Invitees can opt to attend physically or virtually"
                                data-place="top"
                                data-type="info"
                              >
                                Hybrid
                              </label>
                            </div>
                          </li>
                        )}
                      </Field>
                    </>
                  )
                ) : (
                  <InlinePreloader />
                )}
                <Field name="tag">
                  {({ meta }) => (

                    <li className="list-inline-item">
                      {meta.error && meta.touched && (
                        <span style={{ color: "#f44336" }}>{meta.error}</span>
                      )}
                    </li>
                  )}
                </Field>
              </ul>
              {!meetingGroups.loading ? (
                !meetingGroups.error ? (
                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="form-group form-material floating"
                        data-plugin="formMaterial"
                      >
                        <Field name="meeting_group" validate={required}>
                          {({ input, meta }) => (
                            <>
                              <select
                                {...input}
                                id="meeting_group"
                                className="form-control"
                              >
                                <optgroup label="Select meeting group">
                                  <option></option>
                                  {meetingGroups.groups?.map((group) => (
                                    <option key={group.id} value={group.id}>
                                      {group.name}
                                    </option>
                                  ))}
                                </optgroup>
                              </select>
                              {meta.error && meta.touched && (
                                <span style={{ color: "#f44336" }}>
                                  {meta.error}
                                </span>
                              )}
                            </>
                          )}
                        </Field>
                        <OnChange name="meeting_group">
                          {(value) => {
                            if (value) {
                              setMeetingType((pristine) => ({
                                ...pristine,
                                meetingTypeId: parseInt(value),
                              }))
                            }
                          }
                          }
                        </OnChange>
                        <label
                          className="floating-label"
                          htmlFor="meeting_group"
                        >
                          Group<sup>*</sup>
                        </label>
                      </div>
                    </div>
                    {(!form.getState().values.tag ||
                      form.getState().values.tag === "1") && (
                        <div className="col-md-6">
                          <div
                            className="form-group form-material floating"
                            data-plugin="formMaterial"
                          >
                            <Field name="venue" validate={required}>
                              {({ input, meta }) => (
                                <>
                                  <input
                                    {...input}
                                    type="text"
                                    id="venue"
                                    className="form-control"
                                  />
                                  {meta.error && meta.touched && (
                                    <span style={{ color: "#f44336" }}>
                                      {meta.error}
                                    </span>
                                  )}
                                </>
                              )}
                            </Field>
                            <label className="floating-label" htmlFor="venue">
                              Venue<sup>*</sup>
                            </label>
                          </div>
                        </div>
                      )}
                    {form.getState().values.tag &&
                      form.getState().values.tag !== "1" && (
                        <div className="col-md-6">
                          <div
                            className="form-group form-material floating"
                            data-plugin="formMaterial"
                          >
                            <Field name="meeting_host" validate={required}>
                              {({ input, meta }) => (
                                <>
                                  <select
                                    {...input}
                                    id="meeting_host"
                                    className="form-control"
                                  >
                                    <optgroup label="Select virtual host">
                                      <option></option>
                                      {meetingGroups.virtualHosts?.map(
                                        (host) => (
                                          <option
                                            key={host.id}
                                            value={host.email}
                                          >
                                            {host.first_name.concat(
                                              " ",
                                              host.last_name
                                            )}
                                          </option>
                                        )
                                      )}
                                    </optgroup>
                                  </select>
                                  {meta.error && meta.touched && (
                                    <span style={{ color: "#f44336" }}>
                                      {meta.error}
                                    </span>
                                  )}
                                </>
                              )}
                            </Field>
                            <label
                              className="floating-label"
                              htmlFor="meeting_host"
                            >
                              Host<sup>*</sup>
                            </label>
                          </div>
                        </div>
                      )}
                  </div>
                ) : (
                  <p style={{ fontSize: "18px", color: "#f44336" }}>
                    Error fetching groups
                  </p>
                )
              ) : (
                <InlinePreloader />
              )}
              {form.getState().values.meeting_group ? (
                !meetingType.loading ? (
                  !meetingType.error ? (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div
                            className="form-group form-material floating"
                            data-plugin="formMaterial"
                          >
                            <div className="checkbox-custom checkbox-success" style={{ margin: 0 }}>
                              <Field
                                component="input"
                                type="checkbox"
                                id="selectAllInvitees"
                                name="selectAllInvitees"
                              />
                              <label
                                className="floating-label floating-label-static"
                                htmlFor="selectAllInvitees"
                              >
                                Invitees<sup>*</sup>
                              </label>
                              <OnChange name='selectAllInvitees'>
                                {(value) => {
                                  if (value)
                                    isArray(meetingType.users) && form.mutators.setFormAttribute("invitees", meetingType.users.map(x => x.id));
                                  else {
                                    form.mutators.setFormAttribute("invitees", []);
                                  }
                                }}
                              </OnChange>
                            </div>
                            <Field
                              name="invitees"
                              validate={isEmpty}
                              initialValue={initialValueFn}
                            >
                              {(meta) => (
                                <>
                                  <Stack direction="column" spacing={1} sx={{ maxHeight: 130, overflowY: "scroll", bgcolor: '#d3d3d345' }}>
                                    {meetingType.users?.map((user, index) => {
                                      return <div className="checkbox-custom checkbox-success" style={{ margin: 0 }} key={index}>
                                        <Field
                                          id={user.id}
                                          name='invitees'
                                          type="checkbox"
                                          component="input"
                                          value={user.id}
                                        />
                                        <label htmlFor={user.id}>{user.name}</label>
                                      </div>
                                    })}
                                  </Stack>
                                  {
                                    meta?.error && meta.touched && (
                                      <span style={{ color: "#f44336" }}>
                                        {meta.error}
                                      </span>
                                    )
                                  }
                                </>

                              )}
                            </Field>
                          </div>
                        </div>
                        <div className="col-md-6">
                          {form.getState().values.type === "meeting" && (
                            <>
                              <div className="checkbox-custom checkbox-success">
                                <Field
                                  component="input"
                                  type="checkbox"
                                  id="rsvp"
                                  name="rsvp"
                                />
                                <label htmlFor="rsvp">RSVP</label>
                              </div>
                              <div
                                className={classNames(
                                  "alert alert-dismissible",
                                  {
                                    "alert-info": !form.getState().values.rsvp,
                                    "alert-success":
                                      form.getState().values.rsvp,
                                  }
                                )}
                              >
                                <button
                                  className="btn btn-link close"
                                  data-bs-dismiss="alert"
                                  aria-label="close"
                                >
                                  &times;
                                </button>
                                <i
                                  className={classNames("icon", {
                                    "fa-info-circle":
                                      !form.getState().values.rsvp,
                                    "fa-calendar-check-o":
                                      form.getState().values.rsvp,
                                  })}
                                  aria-hidden="true"
                                ></i>{" "}
                                {!form.getState().values.rsvp
                                  ? "Enable RSVP to send meeting calendar invites"
                                  : "Invitees will receive meeting calendar invites"}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      <div
                        className="form-group form-material floating"
                        data-plugin="formMaterial"
                      >
                        <MeetingPackAutocomplete
                          name='meeting_pack'
                          form={form}
                          canCreateFolder={canCreateFolder}
                          group={form.getState().values.meeting_group}
                          options={Array.isArray(meetingType.meetingPacks) ? meetingType.meetingPacks : []}
                          disabled={form.getState().values.meeting_group === null || form.getState().values.meeting_group === undefined}
                        />
                        <OnChange name="meeting_pack">
                          {(value) => {
                            if (value !== undefined && value !== null) {
                              setCanCreateFolder(true);
                              getUserResourcePermissions(value).then(permission => {
                                if (permission?.data?.create_folder)
                                  setCanCreateFolder(true);
                                else {
                                  setCanCreateFolder(false)
                                }
                              }).catch(err => console.log("ERROR"))
                            }

                          }
                          }
                        </OnChange>

                      </div>
                    </>
                  ) : (
                    <p style={{ fontSize: "18px", color: "#f44336" }}>
                      Error fetching group data
                    </p>
                  )
                ) : (
                  <InlinePreloader />
                )
              ) : null}
            </>
          )}
          <div style={{ textAlign: "center", margin: "10px auto" }}>
            <button
              type="submit"
              className="btn btn-raised btn-animate btn-animate-vertical btn-primary btn-sm waves-effect waves-classic"
              disabled={submitting || pristine || !form.getState().values.type || !form.getState().values.invitees || (Array.isArray(form.getState().values.invitees) ? form.getState().values.invitees?.length <= 0 : true)}
            >
              <span>
                <i className="icon pe-diskette" aria-hidden="true"></i>
                &nbsp;Save
              </span>
            </button>
            &nbsp;
            <button
              type="button"
              ref={resetForm}
              className="btn btn-animate btn-animate-vertical btn-default btn-sm waves-effect waves-classic"
              onClick={form.reset}
              disabled={submitting || pristine}
            >
              <span>
                <i className="icon ti-reload" aria-hidden="true"></i>&nbsp;Reset
              </span>
            </button>
          </div>
          {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
        </form >
      }}
    />
  );
};

export default errorHandler(AddEvent, axios);
